import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import Sidebar from './Sidebar';
import Header from './Header';
import { useFirebaseNotification } from '../../contexts/FirebaseNotificationContext';

const Layout = ({notificationCount,setNotificationCount,deliveryNotificationCount,setDeliveryNotificationCount, takeawayNotificationCount,setTakeawayNotificationCount,cateringNotificationCount,setCateringNotificationCount,reservationNotificationCount,setReservationNotificationCount,notificationReload,setNotificationReload}) => {
  // const { notificationCount } = useFirebaseNotification();

  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const saved = localStorage.getItem('sidebar-open');
    return saved !== null ? JSON.parse(saved) : true;
  });
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  const handleSidebarToggle = () => {
    const newState = !sidebarOpen;
    setSidebarOpen(newState);
    localStorage.setItem('sidebar-open', JSON.stringify(newState));
  };

  // console.log("Layout Count => ", notificationCount)

  useEffect(()=>{
      // console.log(notificationReload)
  },[notificationReload])

  return (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh', 
      bgcolor: 'background.default',
      overflowX: 'hidden',
      maxWidth: '100vw'
    }}>
      <Sidebar
      rootNotificationCount={notificationCount}
      setRootNotificationCount = {setNotificationCount}
      rootDeliveryNotificationCount = {deliveryNotificationCount}
      rootTakeawayNotificationCount ={takeawayNotificationCount}
      rootCateringNotificationCount = {cateringNotificationCount}
      setRootDeliveryNotificationCount ={setDeliveryNotificationCount}
      setRootTakeawayNotificationCount = {setTakeawayNotificationCount}
      setRootCateringNotificationCount = {setCateringNotificationCount}
      rootReservationNotificationCount={reservationNotificationCount}     
      setRootReservationNotificationCount = {setReservationNotificationCount}
      notificationReload = {notificationReload}
      setNotificationReload={setNotificationReload}
        open={sidebarOpen}
        onClose={handleSidebarToggle}
        isMobile={isMobile}
      />
      
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          marginLeft: isMobile ? 0 : (sidebarOpen ? '280px' : '80px'),
          overflowX: 'hidden',
          maxWidth: isMobile ? '100vw' : 'calc(100vw - 80px)',
          width: '100%',
        }}
      >
        <Header onSidebarToggle={handleSidebarToggle} 
        rootNotificationCount={notificationCount}
        deliveryNotificationCount = {deliveryNotificationCount}
        takeawayNotificationCount ={takeawayNotificationCount}

        //setRootNotificationCount={setNotificationCount}
         />
        
        <Box
          sx={{
            mt:8,
            flexGrow: 1,
            p: { xs: 1, sm: 1.5, md: 2, lg: 3 },
            bgcolor: 'background.default',
            minHeight: 'calc(100vh - 64px)',
            overflowX: 'hidden',
            maxWidth: '100%',
            width: '100%',
            transition: theme.transitions.create('padding', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
